import { isPdmStructureV2Enabled } from "./isPdmStructureV2Enabled"

/**
 * True when both:
 * - `NEXT_PUBLIC_UPHOLSTERY_PDM_ONLY_VEHICLES=true`
 * - `NEXT_PUBLIC_UPHOLSTERY_PDM_V2_STRUCTURE=true` (PDM V2)
 *
 * When enabled, PDM-listed cars with no Dato `upholsteryCar` load via a
 * synthetic shell instead of throwing VehicleNotFoundError.
 * When off, missing Dato records keep today's "Vehicle not available" warning.
 */
export function isPdmOnlyVehiclesEnabled(): boolean {
  if (!isPdmStructureV2Enabled()) {
    return false
  }

  return (
    typeof process.env.NEXT_PUBLIC_UPHOLSTERY_PDM_ONLY_VEHICLES === "string" &&
    process.env.NEXT_PUBLIC_UPHOLSTERY_PDM_ONLY_VEHICLES.trim().toLowerCase() ===
      "true"
  )
}
